import {
  GET_PLAYLISTS_REQUEST,
  GET_PLAYLISTS_SUCCESS,
  GET_PLAYLISTS_ERROR,
  GET_PLAYLISTS_DONE,
} from "./actions";

import { ADD_PLAYLIST_SUCCESS } from "./add/actions";

import { UPDATE_PLAYLIST_SUCCESS } from "./update/actions";

import {
  DELETE_PLAYLIST_REQUEST,
  DELETE_PLAYLIST_SUCCESS,
  DELETE_PLAYLIST_ERROR,
} from "./delete/actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLAYLISTS_REQUEST:
      return {
        requesting: true,
        successful: false,
        playlists: undefined,
        error: undefined,
      };

    case GET_PLAYLISTS_SUCCESS:
      return {
        requesting: false,
        successful: true,
        playlists: action.playlists,
        error: undefined,
      };

    case GET_PLAYLISTS_ERROR:
      return {
        requesting: false,
        successful: false,
        playlists: undefined,
        error: action.error,
      };

    case GET_PLAYLISTS_DONE:
      return {
        ...initialState,
        successful: state.successful,
        playlists: state.playlists,
      };

    case ADD_PLAYLIST_SUCCESS:
      return {
        ...state,
        playlists: [...state.playlists, action.playlist],
      };

    case UPDATE_PLAYLIST_SUCCESS:
      return {
        ...state,
        playlists: [
          ...state.playlists.map((playlist) => {
            if (playlist.id !== action.playlist.id) {
              return playlist;
            }

            return action.playlist;
          }),
        ],
      };

    case DELETE_PLAYLIST_REQUEST:
      return {
        ...state,
        playlists: [
          ...state.playlists.map((playlist) => {
            if (playlist.id !== action.id) {
              return playlist;
            }

            return { ...playlist, deleting: true };
          }),
        ],
      };

    case DELETE_PLAYLIST_SUCCESS:
      return {
        ...state,
        playlists: [
          ...state.playlists.filter((playlist) => playlist.id !== action.id),
        ],
      };

    case DELETE_PLAYLIST_ERROR:
      return {
        ...state,
        playlists: [
          ...state.playlists.map((playlist) => {
            if (playlist.id !== action.id) {
              return playlist;
            }

            return { ...playlist, deleting: false };
          }),
        ],
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/playlists/reducer.js